import { render, staticRenderFns } from "./question-header-component.vue?vue&type=template&id=2d8b14db&"
import script from "./question-header-component.vue?vue&type=script&lang=ts&"
export * from "./question-header-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports